export interface CompositionsInfoModel {
  productCount: number;
  versionCount: number;
  statusActive: number;
  statusConcept: number;
  statusUnavailable: number;
}

export class CompositionsInfo implements CompositionsInfoModel {
  productCount = -1;
  versionCount = -1;
  statusActive = -1;
  statusConcept = -1;
  statusUnavailable = -1;

  constructor(dto?: CompositionsInfoModel) {
    if (!dto) {
      return;
    }

    Object.assign(this, dto);
  }
}
